import axios from 'axios'

//查询运输单列表
export function getTransList (data) {
  return axios.get(`/manage/shipping-order/list`, { params: data })
}


//查询运输单详情
export function getTrans (id) {
  return axios.get(`/manage/shipping-order/${id}`)
}

//修改运费金额
export function updateFreightAmount (data) {
  return axios.post(`/manage/shipping-order/updateFreightAmount`, data)
}
